// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2LQ6b","footer":"ModalInfo_footer__13smr"};